import {useApiClient} from "../contexts/ApiClientContext";
import {useState} from "react";
import {uploadProductDataFile} from "../api";
import {Flex, Link, Message} from "@aws-amplify/ui-react";
import {FileUpload} from "./FileUpload";
import {UpdateOrdersConfig} from "../api/types";

type UpdateOrdersSettingsProps = {
  config?: UpdateOrdersConfig
}

export const UpdateOrdersSettings = ({config}: UpdateOrdersSettingsProps) => {
  const client = useApiClient();
  const [files, setFiles] = useState<File[]>([]);
  const [changeFile, setChangeFile] = useState(false);
  const [error, setError] = useState<string | undefined>()

  const onSave = async () => {
    if (!client) return Promise.reject('No client')

    try {
      setError(undefined)
      await uploadProductDataFile(client, files[0])
    } catch {
      setError('An error occurred while uploading the file. Please try again.')

      setTimeout(() => {
        setError(undefined)
      }, 5000)
    }

    setFiles([])
    setChangeFile(false)
  }

  return <div>
    <Flex>
      <p style={{fontSize: 14, fontWeight: 'bold', margin: 0}}>Product data file (.xlsx):</p>
      {config?.update_orders_product_data_file_url && !changeFile && (
        <Link href={config.update_orders_product_data_file_url} isExternal={true} style={{marginRight: 5}}>
          Download
        </Link>
      )}
      <Link
        onClick={() => setChangeFile(!changeFile)}>{changeFile ? 'Cancel' : 'Change'}</Link>
    </Flex>
    {changeFile &&
        <div style={{marginTop: 10}}><FileUpload files={files} setFiles={setFiles} onSave={onSave}
                                                 acceptedFileTypes={['.xlsx']}/></div>}
    {error && <Message colorTheme="error" hasIcon={true} style={{marginTop: 10}}>
      {error}
    </Message>}
  </div>
}